module.exports = new __parcel__URL__("puissancebrick.c588632c.webp").toString();